import Cookies from "js-cookie";

const TOKEN_KEY = "authToken";
const USER_KEY = "authUser";
const USER_KEY_LEGACY = "user"; // Your current localStorage key

export const tokenManager = {
  // Your existing functions (updated to use cookies)
  getUser: () => {
    try {
      // First try cookies (new way)
      const authUser = Cookies.get(USER_KEY);
      if (authUser) return JSON.parse(authUser);
      
      // Fallback to localStorage (your current way)
      const user = localStorage.getItem(USER_KEY_LEGACY);
      if (user) return JSON.parse(user);
      
      return null;
    } catch (error) {
      console.error("Error reading auth user:", error);
      return null;
    }
  },

  setUser: (user) => {
    const defaultOptions = { expires: 7, sameSite: "Strict" };
    Cookies.set(USER_KEY, JSON.stringify(user), defaultOptions);
    // Also keep in localStorage for backward compatibility
    localStorage.setItem(USER_KEY_LEGACY, JSON.stringify(user));
  },

  removeUser: () => {
    Cookies.remove(USER_KEY);
    localStorage.removeItem(USER_KEY_LEGACY); // Clean up legacy storage
  },

  // Your existing function names
  isAuthenticated: () => {
    return tokenManager.getUser() !== null;
  },

  // Token methods
  getToken: () => {
    try {
      return Cookies.get(TOKEN_KEY) || null;
    } catch (error) {
      console.error("Error reading auth token from cookies:", error);
      return null;
    }
  },

  setToken: (token, options = {}) => {
    const defaultOptions = { expires: 7, sameSite: "Strict" };
    Cookies.set(TOKEN_KEY, token, { ...defaultOptions, ...options });
  },

  removeToken: () => {
    Cookies.remove(TOKEN_KEY);
  },

  // Combined methods
  setAuth: (token, user, options = {}) => {
    tokenManager.setToken(token, options);
    tokenManager.setUser(user);
  },

  clearAuth: () => {
    tokenManager.removeToken();
    tokenManager.removeUser();
  },

  // Other utility methods...
  isTokenExpired: () => {
    const token = tokenManager.getToken();
    if (!token) return true;
    
    try {
      const payload = JSON.parse(atob(token.split('.')[1]));
      return payload.exp * 1000 < Date.now();
    } catch {
      return true;
    }
  },
};

// Your existing function names for backward compatibility
export const getLoggedInUser = tokenManager.getUser;
export const isUserAuthenticated = tokenManager.isAuthenticated;
export const getAuthToken = tokenManager.getToken;